export function getBaseAPIUrl() {
  return location.host === 'jobian.com'
    ? 'https://api.jobian.com/'
    : 'https://dev-api.jobian.com/'
}
